import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { WindowHelper } from '@core/helpers/window.helper';
import { AppSettingsDto } from '@interfaces/AppSettingsDto';
import { AppSettingsService } from '@shared/services/app-settings.service';

@Component({
  selector: 'pop-data-managment',
  templateUrl: './data-managment.component.html',
  styleUrls: ['./data-managment.component.less']
})
export class DataManagmentComponent extends BaseComponent implements OnInit {
  public config: AppSettingsDto;

  public constructor(private appSettingsService: AppSettingsService) {
    super();
  }

  public ngOnInit(): void {
    this.subscribe(WindowHelper.fixFontSize());
    this.subscribe(
      this.appSettingsService.getAppSettings().subscribe(result => {
        this.config = result;
      })
    );
  }
}
